module.exports = __webpack_public_path__ + "img/tmc-color.7ceb91b.svg";